import { render } from "./CreateQuestionSet.vue?vue&type=template&id=1a6213b9"
import script from "./CreateQuestionSet.vue?vue&type=script&lang=js"
export * from "./CreateQuestionSet.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__